import React, { useEffect } from "react";
import "../privacy.css";
import ScrollTop from "../components/ScrollTop";
const Cookie = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="containers">
        <h1>Cookie Policy</h1>

        <h5 className="mt-4">Introduction</h5>
        <p>
          This Cookie Policy applies to our use of cookies and similar
          technologies on our website www.halalmeats.store. Halalmeats.store is
          a trading name of Meatwala High Wycombe Ltd, a company registered in
          England and Wales (Company Number: 15260965), with its registered
          office at 6 Shelburne Court, High Wycombe, England, HP12 3NH.
        </p>
        <p>
          This policy explains what cookies are, how we use them, and how you
          can manage your preferences.
        </p>

        <h5 className="mt-4">WHO IS THE DATA CONTROLLER?</h5>
        <p>
          The data controller responsible for processing your personal data
          through this website is Meatwala High Wycombe Ltd. If you have any
          questions about our use of cookies or data protection, you can contact
          us at contact@meatwala.co.uk.
        </p>

        <h5 className="mt-4">WHY DO WE HAVE A COOKIE POLICY?</h5>
        <p>
          Under the UK Privacy and Electronic Communications Regulations (PECR)
          and UK GDPR, we must inform you about our use of cookies and obtain
          your consent for certain types of cookies, including analytics,
          marketing, and advertising cookies.
        </p>

        <h5 className="mt-4">WHAT ARE COOKIES?</h5>
        <p>
          Cookies are small text files stored on your device when you visit a
          website. They help websites recognize your device, store preferences,
          and improve the user experience.
        </p>

        <h5 className="mt-4">TYPES OF COOKIES DO WE USE</h5>
        <p>
          There are three types of cookies that we use, Necessary Cookies,
          Analytics Cookies and Marketing Cookies. These cookies perform
          different functions as explained below above the relevant cookies
          sections.
          <ul>
            <li style={{ fontWeight: "700" }}>Necessary Cookies</li>
            <p>
              Essential for the website’s core functions, such as enabling
              security and online transactions. These cookies are always active
              and do not require consent.
            </p>
            <li style={{ fontWeight: "700" }}>Analytics Cookies</li>
            <p>
              Help us track website usage, such as page visits and user
              interactions. We only use these cookies if you provide consent.
            </p>
            <li style={{ fontWeight: "700" }}>Marketing/Advertising Cookies</li>
            <p>
              Used to deliver relevant advertising and measure the effectiveness
              of campaigns. We only use these cookies if you provide consent.
            </p>
          </ul>
        </p>

        <h5 className="mt-4">CONSENT MANAGEMENT</h5>
        <p>
          Necessary cookies are always active. However, you can accept or reject
          analytics and marketing cookies via our Cookie Consent Tool. You can
          also withdraw consent at any time by adjusting your settings in the
          Cookie Consent Tool or browser settings.
        </p>

        <h5 className="mt-4">COOKIES WE USE</h5>
        <p>
          <strong>Google Analytics</strong>
        </p>
        <p>
          We use Google Analytics to collect website usage data. The data may be
          transferred to Google servers in the USA. We have configured Google
          Analytics to ensure compliance with UK GDPR, and data transfers are
          covered by Standard Contractual Clauses (SCCs).
        </p>

        <p>
          GTo opt out, you can download and install the Google Analytics Opt-out
          Browser Add-on:{" "}
          <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">
            https://tools.google.com/dlpage/gaoptout
          </a>
          .
        </p>

        <p className="mt-3">
          <strong>Pixel Cookies and Tags</strong>
        </p>

        <p>
          We use tracking pixels from Facebook, Instagram, and TikTok to measure
          advertisement performance. These collect user interaction data, such
          as clicks and page views, which help us optimize our advertising.
        </p>
        <p>
          For Facebook Pixel, we act as joint controllers with Meta Platforms
          Ireland Ltd, as per their Joint Controller Addendum:
          <a href="https://www.facebook.com/legal/controller_addendum">
            {" "}
            https://www.facebook.com/legal/controller_addendum
          </a>
          .
        </p>
        <p>
          <strong>Google Ads</strong>
        </p>
        <p>
          Google Ads enables us to show relevant advertisements based on your
          interactions with our website. Google Ads Remarketing allows us to
          display personalized ads across different devices. These services are
          only activated with your consent.
        </p>
        <p>
          To adjust your Google Ads settings, visit:{" "}
          <a href="https://adssettings.google.com">
            https://adssettings.google.com
          </a>
        </p>

        <h5 className="mt-4">HOW TO BLOCK COOKIES</h5>
        <p>
          You can disable cookies through your browser settings. However,
          blocking necessary cookies may impact website functionality, including
          order processing and secure transactions.
          <br />
          <br />
          For opt-outs from advertising tracking, visit:
          <ul>
            <li>
              Your Online Choices (Europe):{" "}
              <a href="https://www.youronlinechoices.com">
                https://www.youronlinechoices.com
              </a>
            </li>
            <li>
              Google Ad Settings:{" "}
              <a href="https://adssettings.google.com">
                https://adssettings.google.com
              </a>
            </li>
            <li>
              Network Advertising Initiative:{" "}
              <a href="https://www.networkadvertising.org">
                https://www.networkadvertising.org
              </a>
            </li>
          </ul>
        </p>

        <h5>HELP AND COMPLAINTS</h5>
        <p>
          For further questions about this policy, contact us at{" "}
          <strong>
            <a href="contact@meatwala.co.uk" target="_blank">contact@meatwala.co.uk</a>
          </strong>
          .
        </p>
        <h5>CHANGES TO THIS POLICY </h5>
        <p>
        This policy was last updated on <strong>[3rd March 2025]</strong>. Any future changes will be reflected on this page, and prior versions will no longer be valid.
        </p>
        <p>By continuing to use our website, you acknowledge and accept our use of cookies as described in this policy.</p>
      </div>
      <ScrollTop />
    </>
  );
};

export default Cookie;
